import React from 'react';

const RowWarningIcon = () => {
  return (
    <svg data-test="RowWarningIcon" width="14" height="12" viewBox="0 0 12 10" fill="none" >
    <path fillRule="evenodd" clipRule="evenodd" d="M0 9.46431L6 0L12 9.46431H0ZM10.1078 8.46806L6.00052 1.9875L1.89325 8.46806H10.1078ZM6.54495 6.9737H5.45404V7.96995H6.54495V6.9737ZM5.45404 3.98497H6.54495V5.97746H5.45404V3.98497Z" fill="#D3432F"/>
    </svg>
  );
};

export default RowWarningIcon;
